import { createFileRoute } from '@tanstack/react-router';
import { SupplierOrderPage } from '@/features/purchasing/SupplierOrderPage';

/** A supplier's view of one purchase order, opened from its emailed link. */
export const Route = createFileRoute('/(public)/supplier-order/$token')({
  component: Page,
});

function Page() {
  const { token } = Route.useParams();
  return <SupplierOrderPage token={token} />;
}
